// Central place for brand-related image URLs so we only have to change the
// asset in one place if it ever moves.
export const CARTOMANCER_LOGO =
  "https://customer-assets-wrfwihn1.emergentagent.net/job_8b092a53-b897-4908-960e-e1ef9c5a00e3/artifacts/exsvrik7_Logo%20cartomancer.webp";

export const CARTOMANCER_PREMIUM_LOGO =
  "https://customer-assets-wrfwihn1.emergentagent.net/job_8b092a53-b897-4908-960e-e1ef9c5a00e3/artifacts/kbzr0at7_Logo%20cartomancer%20Premium.png";

export const DISCORD_LOGO =
  "https://customer-assets-wrfwihn1.emergentagent.net/job_8b092a53-b897-4908-960e-e1ef9c5a00e3/artifacts/qxosroe7_Discord%20Logo%20fantasy.png";

export const VTT_LOGO =
  "https://assets.mytharion.app/Mytharion%20VTT%20Logo.png";
  

/**
 * Best-effort check to know whether a product should be presented with the
 * official Cartomancer logo. Includes the virtual `premium_upgrade` product
 * because Premium is a Cartomancer extension.
 */
export const isCartomancerProduct = (productId) =>
  productId === "cartomancer_basic" ||
  productId === "cartomancer_premium" ||
  productId === "premium_upgrade";

/**
 * Return the correct Cartomancer logo variant for a given product id.
 * Premium products (cartomancer_premium, premium_upgrade) get the ornate
 * "Premium" logo; anything else falls back to the standard Cartomancer logo.
 */
export const cartomancerLogoFor = (productId) =>
  productId === "cartomancer_premium" || productId === "premium_upgrade"
    ? CARTOMANCER_PREMIUM_LOGO
    : CARTOMANCER_LOGO;
